/*
 * @Description: 租户管理--爆料账号
 * @Author: zhaoqing
 * @LastEditors: pu.yuchun
 * @Date: 2019-9-17
 * @LastEditTime: 2019-09-18 11:21:14
 */
'use strict';
angular
    .module('brokeNewsAccountModule', [])
    .controller('brokeNewsAccountCtrl', [
        '$scope',
        'trsspliceString',
        '$q',
        '$filter',
        'tManageMentService',
        'modalDialog',
        'trsHttpService',
        function(
            $scope,
            trsspliceString,
            $q,
            $filter,
            tManageMentService,
            modalDialog,
            trsHttpService
        ) {
            // token 租户id
            var token = '',
                tenantId = '';

            $scope.status = {
                isTenantAdmin: 'true',
                searchType: [
                    {
                        name: '创建时间',
                        value: 'crTime'
                    },
                    {
                        name: '重点关注账号',
                        value: 'isFocus'
                    }
                ]
            };

            $scope.data = {
                selectedArray: [],
                tenants: [],
                searchKeywords: '',
                orderKey: $scope.status.searchType[0]
            };

            $scope.page = {
                CURRPAGE: 1,
                ITEMCOUNT: 0,
                PAGECOUNT: 0,
                PAGESIZE: 50
            };

            // 判断用户 管理员/租户
            function isTenantAdmin() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extuser',
                    methodName: 'isAdministrator'
                };
                trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        $scope.status.isTenantAdmin = data.ISADMINISTRATOR;
                        deffer.resolve();
                    });
                return deffer.promise;
            }

            // 获取列表
            function getList() {
                var params = {
                    tenantId: tenantId,
                    curPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE,
                    searchKeywords: $scope.data.searchKeywords,
                    orderKey: $scope.data.orderKey.value
                };
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        '/api/tenantcenter/scoopaccount/getAllByPage',
                        params,
                        'post',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        console.log(data);
                        if (data.code !== '200') {
                            return;
                        }
                        $scope.data.tenants = data.datas;
                        $scope.page.ITEMCOUNT = data.summary_info.total;
                        // $scope.data.selectedArray = data.datas.filter(item => item.status === '已绑定');
                    });
            }
            $scope.requestData = function() {
                getList();
            };

            // 获取当前登录人的信息 获取token
            function getCurrentInfo() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'getCurrUserInfo'
                };
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        trsHttpService.getWCMRootUrl(),
                        params,
                        'get',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        if (data.TENANTID) {
                            tenantId = data.TENANTID;
                            getToken(deffer.resolve);
                        }
                    });
                return deffer.promise;
            }

            // 获取登录token
            function getToken(resolve) {
                var params = {
                    serviceid: 'getToken',
                    tenantId: tenantId
                };
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        trsHttpService.getWCMRootUrl(),
                        params,
                        'get',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        if (data.token) {
                            token = data.token;
                            resolve();
                        }
                    });
            }

            // 判断用户类型 获取token 请求列表
            isTenantAdmin()
                .then(getCurrentInfo)
                .then(getList);

            // 分页 页面跳转
            $scope.jumpToPage = function() {
                getList();
            };

            // 搜索
            $scope.searchHandler = function() {
                $scope.page.CURRPAGE = 1;
                getList();
            };

            // 全选
            $scope.selectAll = function() {
                $scope.data.selectedArray =
                    $scope.data.selectedArray.length ===
                    $scope.data.tenants.length
                        ? []
                        : (function() {
                              var array = [];
                              for (
                                  var i = 0;
                                  i < $scope.data.tenants.length;
                                  i++
                              ) {
                                  array.push($scope.data.tenants[i]);
                              }
                              return array;
                          })();
            };
            // 勾选
            $scope.selectItem = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(
                        $scope.data.selectedArray.indexOf(item),
                        1
                    );
                }
            };

            // 删除
            $scope.deleteHandler = function() {
                if (!$scope.data.selectedArray.length) return;
                modalDialog.confirmModal(
                    '删除',
                    '请确认是否要删除',
                    function() {
                        var ids = $scope.data.selectedArray
                            .map(item => item.accountId)
                            .join();
                        $scope.loadingPromise = trsHttpService
                            .httpServer(
                                '/api/tenantcenter/scoopaccount/delete',
                                {
                                    accountIds: ids
                                },
                                'post',
                                '',
                                { token: token }
                            )
                            .then(function(data) {
                                if (data.code === '200') {
                                    getList();
                                } else {
                                    modalDialog.alertType(
                                        '删除失败!',
                                        '',
                                        'error'
                                    );
                                }
                            });
                    }
                );
            };

            // 获取详情
            function getDetail(item) {
                var deffer = $q.defer();
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        '/api/tenantcenter/scoopaccount/getCurrDetail',
                        {
                            accountId: item.accountId
                        },
                        'post',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        console.log(data);
                        deffer.resolve(data.datas);
                    });
                return deffer.promise;
            }

            // 查看详情
            $scope.showDetail = function(item) {
                getDetail(item).then(function(data) {
                    openModel([token, data, true]);
                });
            };

            // 编辑
            $scope.editTenant = function(item) {
                getDetail(item).then(function(data) {
                    openModel([token, data], getList);
                });
            };

            // 新增
            $scope.addFn = function() {
                openModel([token], getList);
            };

            // 打开弹框
            function openModel(option, fn) {
                tManageMentService.createdBrokeNewsAccount
                    .apply(null, option)
                    .then(
                        function() {
                            fn && fn();
                        },
                        function() {
                            //失败
                        }
                    );
            }

            // 绑定 全部
            // $scope.bindHandler = function() {
            //     modalDialog.confirmModal("", "请确认是否要绑定", function() {
            //         var ids = $scope.data.selectedArray.map(item => item.fieldId).join();
            //         $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/fieldhotpot/bindFieldHot', {
            //             fieldHotIds: ids,
            //             tenantId: tenantId
            //         }, "post", '', {token: token}).then(function(data) {
            //             if (data.code === '200') {
            //                 modalDialog.alertType("绑定成功", "", "success");
            //                 getList();
            //             } else {
            //                 modalDialog.alertType("绑定失败!", "", "error");
            //             }
            //         });
            //     });
            // }
            // 绑定 解绑
            $scope.toggleBind = function(item) {
                var notBind = item.status === 0;
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        '/api/tenantcenter/scoopaccount/bindScoopAccount',
                        {
                            tenantId: tenantId,
                            oprType: notBind ? 1 : 0,
                            scoopAccountIds: item.accountId
                        },
                        'post',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        if (data.code === '200') {
                            item.status = notBind ? 1 : 0;
                        } else {
                            modalDialog.alertType('操作失败!', '', 'error');
                        }
                    });
            };
        }
    ]);
